<div class="space-y-6">
  <div class="flex items-center justify-between">
    <app-page-headline
      [headline]="'pages.clearings.title' | translate"
      [isLoading]="isLoading"
      [count]="total"
    />
  </div>

  <div class="flex flex-col gap-6">
    <div class="flex flex-row gap-6">
      <app-value-filter
        data-test-id="validationFilter"
        [selected]="activeState"
        [isLoading]="isLoading"
        [options]="valueFilterOptions"
        (selectionChange)="onStateFilterChange($event)"
      />
    </div>

    <app-branch-base
      [isLoading]="isLoading"
      [sword]="sword"
      [tableData]="tableData"
      [total]="total"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [activeSorting]="activeSorting"
      [tableColumns]="[
        {
          key: 'actions',
          label: 'pages.clearings.table.actions.label' | translate,
          width: '60px',
          align: 'right',
          fixRight: true,
          cellTemplate: actionCellTemplate,
          sort: false,
        },
      ]"
      [customNoResultText]="'pages.clearings.table.noResultText' | translate"
      (changeHandler)="changeTableHandler($event)"
    />
  </div>
</div>

<ng-template #actionCellTemplate let-currentRow="currentRow">
  <app-button
    class="inline-block"
    data-test-id="editButton"
    type="primary"
    shape="circle"
    [title]="'pages.clearings.table.actions.view.title' | translate"
    [routerLink]="['clearing-detail', currentRow.id]"
  >
    <svg-icon src="assets/icons/General/eye.svg" />
  </app-button>
</ng-template>
